import { useState } from "react";

const Header = () => {
    const [showMoblileMenu, setShowMoblileMenu] = useState(false);
    const [showMoblileMenuItems, setShowMoblileMenuItems] = useState(false);

    const toggleMenu = () => {
        setShowMoblileMenu(!showMoblileMenu);
        setShowMoblileMenuItems(!showMoblileMenuItems);
    };

    return (
        <header id='header'>
            <div className='header container'>
                <div className='nav-bar'>
                    <div className='brand'>
                        <a href='#hero'>
                            <h1>
                                <span>S</span>olomon <span>N</span>jobvu
                            </h1>
                        </a>
                    </div>
                    <div className='nav-list'>
                        <div
                            onClick={toggleMenu}
                            className={
                                showMoblileMenu
                                    ? "hamburger active"
                                    : "hamburger"
                            }
                        >
                            <div className='bar'></div>
                        </div>
                        <ul className={showMoblileMenuItems ? "active" : null}>
                            <li>
                                <a
                                    onClick={toggleMenu}
                                    href='#hero'
                                    data-after='Home'
                                >
                                    Home
                                </a>
                            </li>
                            <li>
                                <a
                                    onClick={toggleMenu}
                                    href='#about'
                                    data-after='About'
                                >
                                    About
                                </a>
                            </li>
                            <li>
                                <a
                                    onClick={toggleMenu}
                                    href='#services'
                                    data-after='Services'
                                >
                                    Services
                                </a>
                            </li>
                            <li>
                                <a
                                    onClick={toggleMenu}
                                    href='#skills'
                                    data-after='Skills'
                                >
                                    Skills
                                </a>
                            </li>
                            <li>
                                <a
                                    onClick={toggleMenu}
                                    href='#projects'
                                    data-after='Projects'
                                >
                                    Projects
                                </a>
                            </li>
                            <li>
                                <a
                                    onClick={toggleMenu}
                                    href='#contact'
                                    data-after='Contact'
                                >
                                    Contact
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
